import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgClass } from '@angular/common';
import { SvgComponent } from '../svg/svg.component';
@Component({
  selector: 'app-photo-info',
  templateUrl: './photo-info.component.html',
  styleUrls: ['./photo-info.component.scss'],
  imports: [SvgComponent, NgClass],
})
export class PhotoInfoComponent {
  private _store = inject(Store);

  @Input() likesCount?: number;

  @Input() isLiked?: boolean;

  @Input() commentCount?: number;
}
